// extracted by css-extract-rspack-plugin
export default {"button":"ProjectTrafficLightStatusSwitcher_button__m3C73"};